import React, {useState,useRef,useEffect } from 'react'
import {Sidebar} from 'primereact/sidebar'
import {Dialog} from 'primereact/dialog'
import { Toast } from 'primereact/toast';
export type BrandingProps = {
    details?: any
    location: "float" | "submit"
    dims?: {gridWidth:number, vw:number, vh:number}
}


export const Branding = ({ dims, details = {}, location}: BrandingProps) => {
    const { affiliate, hide_float:hide, position:initPos } = details || {}
    const [visible, setVisible] = useState(!hide)
    const [showing,setShowing] = useState(false)
    const toast = useRef(null);
    const position = initPos || (dims.vw < dims.gridWidth + 500 ? 'bottom-center' : 'top-right')
    useEffect( () => {
        if(toast.current && !showing){
            toast.current.show({
                severity: 'info',
                sticky: true,
                content:
                    <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                        <div className="text-center">
                        <a  target={'_blank'} rel="noreferrer" href={`https://on2air.com/forms${affiliate ? `?via=${affiliate}` : ''}`}>
                            <div className="font-medium text-500 mb-3">
                                <img src={'https://app.on2air.com/favicon-32x32.png'} style={{paddingRight: '5px', top: '10px', position: 'relative'}}/>
                            Powered By On2Air</div>
                        </a>
                        </div>
                    </div>
                   ,

                closable: false,
                style:{zIndex: 1202, border:0, background:'#ffffff',...(position === 'bottom-center' ? {width:'100%'}:{width:'250px',marginLeft: '70px'})}
            });
            setShowing(true)
        }
    }, [toast.current])
    console.log('Branding',position,  dims)
    // <Dialog visible={visible} position={position} draggable={false} resizable={false} modal={false} closable={false} showHeader={false} onHide={() => setVisible(false)}>
    //     <a target={'_blank'} rel="noreferrer" href={`https://on2air.com/forms${affiliate ? `?via=${affiliate}` : ''}`}><img src={'https://app.on2air.com/favicon-32x32.png'} style={{paddingRight: '5px', top: '10px', position: 'relative'}}/>Powered By On2Air</a>
    // </Dialog>
    return hide || !visible ? ( <></> ) : (
        // <div
        //     style={{
        //         justifyContent: "flex-end",
        //         alignItems: "flex-start",
        //         display: "flex",
        //         position: "fixed",
        //         ...( position === 'bottom' ? {left: '50%', bottom: -40, transform: 'translate(-50%, -50%)', margin: '0 auto'} : {top: 10,right: 15}),
        //         zIndex: 1102,
        //         minWidth: '300px'
        //     }}
        // >
        // <div
        //     className="surface-0 p-4 shadow-2 border-round"
        //     style={{ display: "flex" }}
        // >
        //     <a target={'_blank'} rel="noreferrer" href={`https://on2air.com/forms${affiliate ? `?via=${affiliate}` : ''}`}>
        //         <div className="font-medium text-500 mb-3">
        //             <img src={'https://app.on2air.com/favicon-32x32.png'} style={{paddingRight: '5px', top: '10px', position: 'relative'}}/>
        //         Powered By On2Air</div>
        //     </a>
        // </div>
        // </div>
        <Toast ref={toast} position={position} />
    )
}